import {
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
  SimpleChanges,
} from "@angular/core";
import { ControlContainer, FormGroupDirective } from "@angular/forms";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";
import { CommonService } from "@services/common.service";
import { MatAccordion } from "@angular/material/expansion";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
import { environment } from "@environments/environment";

@Component({
    selector: "app-options",
    templateUrl: "./options.component.html",
    styleUrls: ["./options.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class OptionsComponent implements OnInit, OnChanges {
  faChevronRight = faChevronRight;
  faChevronDown = faChevronDown;

  @Input() charts!: any;
  @Input() currentDataFields!: any;
  @Input() manualChartColors!: any;

  @Input() visibleDataPoints!: any;
  @Input() appliedSeries!: any;
  @Input() workflows!: any;
  @Input() currentFilterFields!: any;
  @Input() sortFields!: any;
  @Input() canvasOptions!: any;
  @Input() groupFields!: any;
  @Input() canAddModifiers!: boolean;
  @Input() openFirst!: boolean;
  @Input() formatdata!: any;
  @Input() chartType!: any;
  @Input() chartData!: any;
  @Input() calculationOptions!: any;
  @Input() isVisible?: boolean;

  open: boolean = true;
  @ViewChild("accordion") accordion!: MatAccordion;
  settingsPanelOpenState = false;

  filterPanelOpenState = false;
  sortPanelOpenState = false;
  formatPanelOpenState = false;
  linkingPanelOpenState = false;
  coloringPanelOpenState = false;
  departmentScope: boolean = false;
  departmentScopeLength: number = 0;
  employeeScope: boolean = false;
  employeeScopeLength: number = 0;
  faExclamationTriangle = faExclamationTriangle;
  public featureFlags: any = [];

  constructor(
    public parentForm: FormGroupDirective,
    public commonService: CommonService
  ) {}
  childForm: any;

  ngOnChanges(changes: SimpleChanges) {
    this.childForm = this.parentForm.form;
    this.featureFlags = JSON.parse(sessionStorage.getItem("featureFlags"));

    if (this.childForm) {
      this.departmentScope = this.childForm.get("departmentScope").value;
      if (this.departmentScope) this.departmentScopeLength = 1;
      else this.departmentScopeLength = 0;

      this.employeeScope = this.childForm.get("employeeScope").value;
      if (this.employeeScope) this.employeeScopeLength = 1;
      else this.employeeScopeLength = 0;
    }

    if (this.isVisible) {
      if (this.openFirst && this.accordion && !this.settingsPanelOpenState) {
        this.accordion.closeAll();
        this.open = false;
        if (this.currentDataFields && this.currentDataFields.length > 0) {
          setTimeout(() => {
            this.open = true;
          }, 100);
        }
      }
      if (!this.currentDataFields || this.currentDataFields.length <= 0) {
        this.open = false;
        if (this.accordion) this.accordion.closeAll();
        this.canAddModifiers = false;
      } else {
        this.canAddModifiers = true;
      }
    } else {
      this.open = false;
      if (this.accordion) this.accordion.closeAll();
      //this.open = false;
      this.canAddModifiers = false;
    }
  }
  ngOnInit(): void {
    this.childForm = this.parentForm.form;
    if (this.childForm) {
      this.departmentScope = this.childForm.get("departmentScope").value;
      if (this.departmentScope) this.departmentScopeLength = 1;
      else this.departmentScopeLength = 0;

      this.employeeScope = this.childForm.get("employeeScope").value;
      if (this.employeeScope) this.employeeScopeLength = 1;
      else this.employeeScopeLength = 0;
    }
  }
}
